import React from 'react'
import Navbar from '../inc/Navbar'
import ScrollToTop from "react-scroll-to-top";
import { Link } from "react-router-dom";

import ReactPlayer from "react-player";
import AddQueries from '../AddQueries';


function Handcraft() {
  return (
    <div>
      <Navbar />
      <br />
      <br />
      <br />
      <br />
      <ScrollToTop smooth top="100" color="Darkblue" />
      <div className='exportindian'>
        <div className="album py-1">
          <div className="container mt-3">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/" >Home</Link></li>
                <li className="breadcrumb-item active" aria-current="page">Handcraft Products</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <br />
      <div className="album py-0">
        <div className="container">
          <div className="row">
            <div className="col-md-4 mt-3">
              <div className=" mb-4">
                <ReactPlayer className="mb-2" width="100%" height="100%" url="https://www.youtube.com/watch?v=pRw9ytLB07A" />
                <div className="card-body">
                  <div className='colorrice'>
                    <h5 className="card-text mt-2 mb-2"> <b>
                      Handcraft</b></h5>
                  </div>
                  <p>Top Handcrafted Products for Global Export: Quality Creations You’ll Love</p>

                  <div className="d-flex justify-content-between align-items-center">



                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="album py-0">
        <div className="container">
          <div className="row">
            <div className="col-md-3 mt-3">
              <div className="d-flex justify-content-between align-items-center">
                <a className='callbutton' href='tel: +91 8695269630'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-minus" viewBox="0 0 16 16">
                  <path fill-rule="evenodd" d="M10 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5" />
                  <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z" />
                </svg> 8695269630</a>

                <button type="button" className="callbutton" data-bs-toggle="modal" data-bs-target="#exampleModal">
                  Enquiry
                </button>


                <div className="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                  <div className="modal-dialog">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">Best Quality Handcraft Products</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                      </div>
                      <div className="modal-body">
                        .<AddQueries />
                      </div>
                      <div className="modal-footer">
                        <button type="button" className="closebutton" data-bs-dismiss="modal">Close</button>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
      <br />
    </div>
  )
}

export default Handcraft